import { createFileRoute } from '@tanstack/react-router';
import { useLingui } from '@lingui/react/macro';
import { Header } from './-components/header';
import { Footer } from './-components/footer';
import { Layout } from './-components/layout';

export const Route = createFileRoute('/new/')({
	component: Component,
});

/**
 * Home placeholder for the redesigned site. This Story (TEC-3623) only delivers the
 * shared foundation — Header, Footer, mobile Menu, tokens and the responsive baseline;
 * the homepage content lands in its own Story. Keeping the shared chrome here proves the
 * layout is reusable by every page.
 */
function Component() {
	const { t } = useLingui();
	return (
		<Layout>
			<Header />
			<div className="mx-auto flex max-w-[1440px] flex-col items-center gap-6 px-6 py-32 text-center">
				<h1 className="text-5xl font-semibold md:text-7xl">{t`Small donations, big causes`}</h1>
				<p className="text-ink/70 max-w-2xl text-xl">{t`Shared foundation ready — pages land in their own Stories.`}</p>
			</div>
			<Footer />
		</Layout>
	);
}
